<template>
  <div class="novidades-resource-index">
    <h3 class="novidades-resource-index__title">
      Índice de Recursos ({{ items.length }})
    </h3>
    <ul class="novidades-resource-index__list">
      <li
        v-for="(item, idx) in items"
        :key="item.id || idx"
        class="novidades-resource-index__item"
      >
        <button
          type="button"
          class="novidades-resource-index__link"
          @click="scrollToItem(idx)"
        >
          <span>{{ item.emoji || "•" }}</span>
          <span class="novidades-resource-index__link-text">{{
            item.title
          }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "NovidadesResourceIndex",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    scrollToItem(index) {
      const el = document.getElementById(`novidade-item-${index}`);
      if (el && el.scrollIntoView) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }
};
</script>
